import { AppService } from 'SERVICES';

export default (getUpgradePrices) => {
  AppService.upgradePrices().then(({ data }) => {
    getUpgradePrices(data.data);
  }).catch((error) => {
    console.log(error);
  });
};
